import React from 'react';
import { FORGOT_PASSWORD_URL, REGISTER_URL } from '../../../config';
import { useFlow } from '../../../contexts/FlowContext';
import { getForgotPasswordRedirectUrl, getRegisterRedirectUrl } from '../../../utils/nativeApp';

interface BusinessErrorMessageProps {
  isVisible: boolean;
}

const BusinessErrorMessage: React.FC<BusinessErrorMessageProps> = ({ isVisible }) => {
  const { getFlowData } = useFlow();
  const isNativeApp = getFlowData('device') === 'native_app';

  if (!isVisible) return null;

  return (
    <div className="business-error-container">
      <div className="errorList">
        <strong tabIndex={0}>Sorry, we can't complete your login. Here are a few possible reasons why:</strong>
        <ul>
          <li>
            <span tabIndex={0}>
              Incorrect username and password. Please try again or{' '}
              <a
                href={isNativeApp ? getForgotPasswordRedirectUrl() : FORGOT_PASSWORD_URL}
                className="highlightBlue line"
                {...(!isNativeApp && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                reset your username or password
              </a>
              . Note that your account will be locked after more than six incorrect attempts.
            </span>
          </li>
          <li>
            <span tabIndex={0}>
              You might have reached the maximum number of log-in attempts, and for security reasons, 
              your account might be locked.
            </span>
          </li>
          <li>
            <span tabIndex={0}>
              You're not signed up to use our site.{' '}
              <a
                href={isNativeApp ? getRegisterRedirectUrl() : REGISTER_URL}
                className="highlightBlue line"
                {...(!isNativeApp && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                Register now
              </a>.
            </span>
          </li>
          <li>
            <span tabIndex={0}>Online access isn't enabled for your plan.</span>
          </li>
          <li>
            <span tabIndex={0}>
              If you're an Anthem or Wellpoint member, your pharmacy benefits aren't available on the 
              CarelonRx website. Please use the health plan log-in links located on this page.
            </span>
          </li>
        </ul>
        <strong tabIndex={0}>
          If none of these reasons apply to you, our website could be experiencing technical difficulties. 
          Please try again later.
        </strong>
        <ul>
          <li>
            <span tabIndex={0}>
              If you continue to have trouble logging in and need support, 
              please contact our Technical Support team at{' '}
              <a className="highlightBlue line" href="tel:1-844-430-0335">
                1-844-430-0335
              </a>
            </span>
            <span tabIndex={0}> (TTY: 711), Monday - Friday, 8 a.m. to 8 p.m. ET.</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BusinessErrorMessage;
